export const azulMonocromatico20  = [
      '#AACFF0', // mais claro
      '#9AC3EB',
      '#8AB7E6',
      '#7AABE1',
      '#6A9FDC',
      '#5A93D7',
      '#4A87D2',
      '#3E7ACC',
      '#3366CC', // cor base
      '#2F5EB8',
      '#2A56A3',
      '#264F8F',
      '#21477A',
      '#1D3F66',
      '#183852',
      '#14303D',
      '#102829',
      '#0D2020',
      '#091818',
      '#050F10'  // mais escuro
    ];

export const verdeMonocromatico20 = [
  '#080A04', // mais claro (leve e escurecido)
  '#090C05',
  '#0A0F06',
  '#0B1308',
  '#0C180B',
  '#0D1E0D',
  '#0E2510',
  '#0F2D13',
  '#103516',
  '#123E1A',
  '#13471D',
  '#155121',
  '#175B25',
  '#196428', // mais escuro (verde intenso e profundo)
  '#1B6E2C',
  '#1D7830',
  '#1F8234',
  '#218C38',
  '#23963C',
  '#26A040'
];


export const vermelhoMonocromatico20 = [
  '#070000', // mais claro (vermelho escurecido)
  '#0D0101',
  '#140202',
  '#1B0303',
  '#250505',
  '#2F0607',
  '#3A080A',
  '#46090D',
  '#510B10',
  '#5D0C13', // mais escuro (tom base)
  '#690E17',
  '#75101A',
  '#81121E',
  '#8D1422',
  '#991625',
  '#A51929',
  '#B11C2D',
  '#BD1F30',
  '#C92234',
  '#D72638'
];


export const laranjaMonocromatico20 = [
    '#FF9900', // mais claro (base vibrante)
    '#F28C00',
    '#E67F00',
    '#D97200',
    '#CD6600',
    '#C15900',
    '#B44D00',
    '#A84000',
    '#9C3400',
    '#902800',
    '#841C00',
    '#781200',
    '#6C0A00',
    '#600700',
    '#540500',
    '#480400',
    '#3C0300',
    '#300200',
    '#240100',
    '#180000'  // mais escuro com leve laranja queimado
];

export const amareloMonocromatico20 = [
    '#FFCC00', // mais claro (amarelo vivo base)
    '#F2BF00',
    '#E6B300',
    '#D9A600',
    '#CD9900',
    '#C18D00',
    '#B48000',
    '#A87400',
    '#9C6700',
    '#905A00',
    '#844E00',
    '#784100',
    '#6C3500',
    '#602800',
    '#541C00',
    '#481000',
    '#3C0900',
    '#300600',
    '#240400',
    '#180200'  // mais escuro, com dourado queimado
];